import { CONTRACTOR_CLIENTS_CRUD_ACTION_CREATORS } from '../actions/contractor_clients_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import {
	fetchDistinctSupplierPrivateNetworksSuccess,
	SUPPLIER_PRIVATE_NETWORKS_CRUD_ACTION_CREATORS,
} from '../actions/supplier_private_networks_actions';
import FetchUtils, { parseJSON } from './fetch_utils';
import { logoutSuccess } from '../actions/session_actions';
import { getBackendUri } from '../utils/EnvConfigUtils';

const fetchUtils = new FetchUtils();
const baseUrl = getBackendUri();

export const contractorClientsRestCrudThunksForBuyer = new RestCrudThunks(
	'clients',
	'client',
	'client',
	'clients',
	CONTRACTOR_CLIENTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'contractor/'
);
export const contractorClientsRestCrudThunksForSupplier = new RestCrudThunks(
	'clients',
	'client',
	'client',
	'clients',
	CONTRACTOR_CLIENTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'contractor/'
);

export const inviteAdminsForClientBuyerCompany = (id, email, contact) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.post(baseUrl + `/api/v1/supplier/buyers/${id}/buyer_sign_up_invite/${email}`, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: contact,
				})
				.then(parseJSON)
				.then((d) => {
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};
